var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { focusVisibleRing, focusVisibleRingError } from './constants';
const inputVariants = cva([
    'placeholder:text-foreground-muted text-foreground dark:border-input selection:bg-primary selection:text-primary-foreground file:text-foreground flex w-full min-w-0 rounded-md border border-gray-200 bg-transparent px-3 text-sm leading-5 shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
    focusVisibleRing,
    focusVisibleRingError,
], {
    defaultVariants: {
        size: 'md',
    },
    variants: {
        size: {
            sm: 'h-9 py-2',
            md: 'h-10 py-2.5',
        },
    },
});
const Input = forwardRef((_a, ref) => {
    var { className, type, size } = _a, props = __rest(_a, ["className", "type", "size"]);
    return (_jsx("input", Object.assign({ ref: ref, type: type, "data-slot": "input", className: cn(inputVariants({ size }), className) }, props)));
});
Input.displayName = 'Input';
export { Input };
